import axios from 'axios';
export default class SidebarService{

  close(){
    const _ = this;
    let sidebar: any = document.querySelector('.sidebar-component');
    sidebar.classList.remove('active');
  }
}
